import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AnalyticsContext } from './context.js';

var _excluded = ["product", "list", "position"];

/**
 * <Link /> replacement notifying google analytics about the clicked product,
 * accepts all of <Link />'s props
 * in addition to the ones listed on this class.
 */
var ProductLink = function ProductLink(props) {
  var context = useContext(AnalyticsContext); // Exclude <ProductLink /> specific attributes

  var product = props.product,
      list = props.list,
      position = props.position,
      linkProps = _objectWithoutPropertiesLoose(props, _excluded);

  var onClickLink = function onClickLink(e) {
    if (process.env.NODE_ENV !== "production" && !context && typeof window !== "undefined") {
      throw new Error("<ProductLink /> must be wrapped in a <AnalyticsProvider />");
    }

    context.registerProductClick(product, list, position);

    if (props.onClick !== undefined) {
      props.onClick(e);
    }
  };

  return /*#__PURE__*/React.createElement(Link, _extends({}, linkProps, {
    onClick: onClickLink
  }), props.children);
};

export { ProductLink };
//# sourceMappingURL=product-link.js.map
